import firebase from "firebase";

var firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_CONFIG_API_KEY,
  authDomain: "allnewsaggr.firebaseapp.com",
  databaseURL: "https://allnewsaggr.firebaseio.com",
  projectId: "allnewsaggr",
  storageBucket: "allnewsaggr.appspot.com",
  messagingSenderId: "387016070615",
  appId: "1:387016070615:web:7d2690b9bfad74b2f26792",
  measurementId: "G-SN119VS7MC",
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.analytics();

const db = firebaseApp.firestore();

export default db;
